import React from "react";
import Card from "@material-ui/core/Card";
import QuestionIcon from "@material-ui/icons/QuestionAnswer";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import CardIcon from "../components/CardIcon";

const styles = {
  main: {
    flex: "1",
    marginRight: "1em",
    marginTop: 20
  },
  card: {
    overflow: "inherit",
    textAlign: "right",
    padding: 16,
    minHeight: 52
  }
};

const QuestionsCount = ({ stats, classes }) => (
  <div className={classes.main}>
    <CardIcon Icon={QuestionIcon} bgColor="#ff9800" />
    <Card className={classes.card}>
      <Typography color="textSecondary">問題數量</Typography>
      <Typography variant="headline" component="h2">
        {stats ? stats.content.total : "讀取中"}
      </Typography>
    </Card>
  </div>
);

QuestionsCount.defaultProps = {
  stats: null
};

export default withStyles(styles)(QuestionsCount);
